import { createAsyncThunk } from "@reduxjs/toolkit"
import axiosAPI from "../../api/axiosAPI"

export const uploadImage = createAsyncThunk("uploadImage", async (data) => {
    try {
        console.log({data})
        const response = await axiosAPI.post("/upload-image", data);
        return response
    } catch (err) {
        return err
    }
})

export const uploadThumbnail = createAsyncThunk("uploadThumbnail", async (data) => {
    try {
        console.log({data})
        const response = await axiosAPI.post("/upload-thumbnail", data);
        return response
    } catch (err) {
        return err
    }
})

export const uploadProfile = createAsyncThunk("uploadProfile", async (data) => {
    try {
        const { userId, formData } = data
        const response = await axiosAPI.post(`/upload-profile/${userId}`, formData);
        return response
    } catch (err) {
        return err
    }
})